<div class="download-asset-mode-title">
  <h1 class="title">Shopify Sync Output Assets</h1>
  @if (isLoading) {
    <mat-spinner class="spinner"></mat-spinner>
  }
</div>
<mat-dialog-content class="download-asset-model">
  @if (!isLoading) {
    <div class="output-setting">
      <div class="header">
        <i class="material-icons">crop</i>
        <h3 class="title">Output Formulas</h3>
      </div>
      @for (formats of outputForms; track formats) {
        <div class="item">
          <div class="info">
            <mat-checkbox
              class="custom-checkbox"
              (change)="formats.get('checked')?.setValue($event.checked)"
              color="primary"
            ></mat-checkbox>
            <span class="name">{{ formats.get("name")?.value }} </span>
            <span class="configText" style="margin-left: 20px">{{ formats.get("configText")?.value }}</span>
          </div>
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="action">
  <mat-checkbox
    [formControl]="overwrite"
    class="custom-checkbox"
    color="primary"
    >
    Overwrite
  </mat-checkbox>
  <span class="spacer"></span>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button
    mat-stroked-button
    color="buttonSuccess"
    class="save"
    cdkFocusInitial
    (click)="generate()"
    >
    @if (isDownload) {
      <mat-icon
        ><mat-spinner color="accent" diameter="20"> </mat-spinner></mat-icon
        >
      }Sync
    </button>
  </mat-dialog-actions>
